import { useCallback, useMemo } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LINE_ITEM_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import unescapedText from 'I18n/utils/unescapedText';
import AssociationInput from './AssociationInput';
import AssociationLabelInput from './AssociationLabelInput';
import { getFieldNameFromAssociationId } from '../../form/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssociationAndLabelInputContainer = ({
  associationDefinition,
  associationLabelDefinition,
  associationDefinitions,
  associationValue,
  cachedAssociationValuesForField,
  id,
  labelValue,
  onAssociationChange,
  onLabelChange,
  associationError = false,
  labelError = false,
  associationValidationMessage,
  labelValidationMessage,
  required = false,
  objectTypeId,
  isLabelRequired,
  isMulti = false,
  hideLabelInput
}) => {
  var _cachedAssociationVal;
  const handleAssociationChange = useCallback(event => {
    onAssociationChange(event);
  }, [onAssociationChange]);
  const handleLabelChange = useCallback(event => {
    onLabelChange(event);
  }, [onLabelChange]);
  const toObjectTypeId = associationDefinition.toObjectTypeId;
  const filteredAssociationDefinitions = associationDefinitions.filter(definition => definition.toObjectTypeId === toObjectTypeId);
  const associationRecordTooltip = useMemo(() => {
    if (!isMulti) {
      return unescapedText('customerDataProperties.AssociationAndLabelInputContainer.oneToOneTooltip');
    }
    return null;
  }, [isMulti]);
  const singularForm = associationDefinition.toObjectTypeDefinition.singularForm;
  const pluralForm = associationDefinition.toObjectTypeDefinition.pluralForm;
  const allowsMoreThanOneAssociation = associationLabelDefinition.maxToObjectIds > 1 && associationDefinition.maxToObjectIds > 1;
  const isOneToOne = !allowsMoreThanOneAssociation;
  const fieldName = getFieldNameFromAssociationId(id);
  const disabled = fieldName ? Boolean(isOneToOne && ((_cachedAssociationVal = cachedAssociationValuesForField.value) === null || _cachedAssociationVal === void 0 || (_cachedAssociationVal = _cachedAssociationVal.objectIds) === null || _cachedAssociationVal === void 0 ? void 0 : _cachedAssociationVal.length)) : false;

  // TO DO [Conditional Associations]: Add Line Item input support post-MVP
  // https://git.hubteam.com/HubSpot/CreateAndAssociateFrontendTeam/issues/1236
  if (toObjectTypeId === LINE_ITEM_TYPE_ID) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: !isMulti ? unescapedText('customerDataProperties.AssociationAndLabelInputContainer.associateSingular', {
        singularForm
      }) : unescapedText('customerDataProperties.AssociationAndLabelInputContainer.associatePlural', {
        pluralForm
      }),
      "data-test-id": `association-field-${id}`,
      required: required,
      error: associationError,
      validationMessage: associationValidationMessage,
      tooltip: associationRecordTooltip,
      children: /*#__PURE__*/_jsx(AssociationInput, {
        associationDefinition: associationDefinition,
        cachedAssociationValuesForField: cachedAssociationValuesForField,
        value: associationValue,
        onChange: handleAssociationChange,
        disabled: disabled,
        isMulti: isMulti,
        clearable: true,
        placeholder: isMulti ? unescapedText('customerDataProperties.AssociationAndLabelInputContainer.selectPlural', {
          singularForm
        }) : unescapedText('customerDataProperties.AssociationAndLabelInputContainer.selectSingular', {
          singularForm
        }),
        id: id
      })
    }), !hideLabelInput && /*#__PURE__*/_jsx(AssociationLabelInput, {
      associationLabelDefinition: associationLabelDefinition,
      associationDefinitions: filteredAssociationDefinitions,
      id: id,
      value: labelValue,
      recordIds: associationValue,
      onChange: handleLabelChange,
      error: labelError,
      validationMessage: labelValidationMessage,
      disabled: disabled,
      objectTypeId: objectTypeId,
      isLabelRequired: isLabelRequired
    })]
  });
};
export default AssociationAndLabelInputContainer;